import { Box, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TooltipModal from '@/components/shared/tooltip-modal';
import type { FlashcardDeck, FlashcardDecksAndStats } from '@/types';

export default function FlashcardDeckStats({
  stats: { newRemaining, learning, relearning, review },
  allDeckStats,
}: {
  stats: FlashcardDeck['stats'];
  allDeckStats?: FlashcardDecksAndStats['stats'];
}) {
  const { t } = useTranslation();
  const { newPerDay, newRemainingToday } = allDeckStats ?? {
    newPerDay: 0,
    newRemainingToday: 0,
  };
  const cardWordNew = t('flashcard.common.card', { count: newRemaining });
  const learningCount = learning + relearning;
  const cardWordLearning = t('flashcard.common.card', { count: learningCount });
  const cardWordReview = t('flashcard.common.card', { count: review });
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1,
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
      }}>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <TooltipModal
          title={t('flashcard.deckStats.tooltipNew', {
            count: newRemaining,
            cards: cardWordNew,
          })}>
          <Chip
            size="small"
            variant="outlined"
            color="info"
            label={t('flashcard.deckStats.chipNew', { count: newRemaining })}
          />
        </TooltipModal>
        <TooltipModal
          title={t('flashcard.deckStats.tooltipLearning', {
            count: learningCount,
            cards: cardWordLearning,
          })}>
          <Chip
            size="small"
            variant="outlined"
            color="warning"
            label={t('flashcard.deckStats.chipLearning', {
              count: learningCount,
            })}
          />
        </TooltipModal>
        <TooltipModal
          title={t('flashcard.deckStats.tooltipReview', {
            count: review,
            cards: cardWordReview,
          })}>
          <Chip
            size="small"
            variant="outlined"
            color="error"
            label={t('flashcard.deckStats.chipReview', { count: review })}
          />
        </TooltipModal>
      </Box>
      {allDeckStats && (
        <TooltipModal
          title={t('flashcard.deckStats.chipAllDecksToday', {
            done: newPerDay - newRemainingToday,
            total: newPerDay,
          })}>
          <Chip
            size="small"
            variant="outlined"
            color="primary"
            label={t('flashcard.deckStats.chipAllDecksToday', {
              done: newPerDay - newRemainingToday,
              total: newPerDay,
            })}
            sx={{ alignSelf: 'flex-start' }}
          />
        </TooltipModal>
      )}
    </Box>
  );
}
